import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-submit-toggle-timeout', function (button) {
        setTimeout(function () {
            button.removeAttribute('disabled');
        }, 30000);
    });
}